(function () {
    'use strict';

    // Filter to do a distinct on an array made up of codevalue objects
    // Usage: {{ codeArray | distinctCode}}
    angular.module('app').filter('distinctCode', FilterFactory);
    function FilterFactory() {
        return function (codeFunctions) {
            if (!codeFunctions) return null;
            const newArray = [];
            codeFunctions.forEach((x) => {
                if (newArray.filter(y => y.Value === x.Value).length === 0)
                    newArray.push(x);
            });
            return newArray;
        };
    }
})();